import { registerQuery } from 'data-fetching-client';
import { ecosystemAppClient } from 'marketplace-ui-common/clients/ecosystemClient';
export const GET_EDITABILITY = registerQuery({
  fieldName: 'editability',
  fetcher: ({
    reviewId
  }) => ecosystemAppClient.get(`reviews/${reviewId}/editability`)
});